// extracted by mini-css-extract-plugin
export default {"imageContainer":"e2-z","summaryPar":"f2-z","ratingCategories":"g2-z","reviewerInfo":"h2-z","reviewTypes":"i2-z","expanded":"j2-z"};